import { render, staticRenderFns } from "./MessageTicketEdit.vue?vue&type=template&id=3fe4f72b"
import script from "./MessageTicketEdit.vue?vue&type=script&lang=js"
export * from "./MessageTicketEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports